import Glide from '@glidejs/glide'
import YoutubePlayer from "../../Molecule/YouTubePlayer/YouTubePlayer";

export default class YouTubeGrid {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.youtube-grid'), el => {
            new YouTubeGrid(el)
        });
    }

    static classes = {
        node: 'youtube-grid',
        player: 'youtube-grid__player',
        grid: {slide: 'glide__slide'}
    }

    constructor(el) {
        if (!el) return;
        this.el = el;
        this.sliderNode = el.querySelector('.youtube-grid__slider');

        this.options = {
            type: 'slide',
            perView: 3,
            autoplay: false,
            gap: 16,
            peek: {before: 0, after: 100},
            rewind: false,
            arrows: true,
            bullet: false,
            animationDuration: 500,
            animationTimingFunc: 'ease',
            breakpoints: {
                1024: {
                    perView: 2,
                    peek: {before: 0, after: 64},
                },
                768: {
                    perView: 2,
                    peek: 32,
                },
            }
        };

        let currentPerPage = window.innerWidth > 1024 ? this.options.perView : window.innerWidth > 768 ? this.options.breakpoints['1024'].perView : this.options.breakpoints['768'].perView;
        let initialSlidesToLoad = currentPerPage + 2;
        this.slider = new Glide(this.sliderNode, this.options);

        // make first slide video active
        this.player = YoutubePlayer.getPlayerById(this.el.querySelector('.youtube-player__inner').dataset.id);
        this.player.startPlayerOnReady(); // we need this to get the playlist below

        this.player.element.addEventListener('stateChange', e => {
            if (e.detail === 'cued') {
                this.createSlides(this.player.getPlaylist());

                for (let i = 0; i < initialSlidesToLoad; i++) {
                    this.initPlayer(this.player.getPlaylist()[i]);
                }

                this.slider.on('move', () => {
                    let nextSlideToLoadIndex = this.slider.index + initialSlidesToLoad;
                    if (nextSlideToLoadIndex <= this.player.getPlaylist().length) {
                        this.initPlayer(this.player.getPlaylist()[nextSlideToLoadIndex]);
                    }
                });

                this.slider.mount();
            }
        });
    }


    createSlides(list) {
        const slidesWrapper = this.sliderNode.querySelector('.glide__slides');
        const sample = this.el.querySelector('.youtube-slider-item-player-template').content.childNodes[0];

        list.forEach(el => {
            const item = sample.cloneNode(true);
            const itemInner = item.querySelector('.youtube-slider-item-player__inner');
            const itemIframe = item.querySelector('.youtube-slider-item-player__iframe');
            itemInner.dataset.id = el;
            itemIframe.dataset.id = el;
            item.dataset.id = el;
            item.classList.add('glide__slide');
            item.classList.add('youtube-player');

            item.addEventListener('click', () => {
                this.player.player.loadVideoById(el);
                Array.from(this.sliderNode.querySelectorAll('.glide__slide')).forEach(_el => {
                    _el.querySelector('.youtube-slider-item-player__inner__title').classList.remove('text-primary');
                });
                item.querySelector('.youtube-slider-item-player__inner__title').classList.add('text-primary');
            });

            Array.from(item.querySelectorAll('.youtube-player__poster source, .youtube-player__poster img')).forEach(_el => {
                _el.src = _el.src.replace('{id}', el);
                _el.srcset = _el.srcset.replace('{id}', el);
            });

            slidesWrapper.appendChild(item);
        });
    }

    setTitle = (el, title) => {
        el.querySelector('.youtube-slider-item-player__inner__title').innerText = title;
    }

    initPlayer(id) {
        const item = this.el.querySelector(`.youtube-slider-item-player[data-id="${id}"]`);
        const itemIframe = item.querySelector('.youtube-slider-item-player__iframe');

        return new YT.Player(itemIframe, {
            videoId: id,
            events: {
                'onReady': (e) => {
                    this.setTitle(item, e.target.videoTitle);
                    item.querySelector('.youtube-slider-item-player__preloader').classList.add('hidden');
                }
            }
        });
    }
}
